import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import ItemGroup from './ItemGroup';
import { Card, Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import NoDataLayer from '../../../../../Common/NoDataLayer';
import MainAppContext from '../../../../../../MainAppContext';
import { t } from 'i18next';
import ItemGroupCombined from './ItemGroupCombined';
import './style.css'

function SG3KPI_CONTRACT_ADVANCE(props) {
    const contextSite = useContext(MainAppContext);
    const { _boardStructure: objBoard } = useSelector((state) => state.boardScope);

    const { 
		inputParam_ComponentContent = null,
		inputParam_BoardStructure = null,
        inputParam_Container = null
	} = props;

    const objValues = [
        { 
            id: 1, variableName: "Plazo",
            l_vals: [
                {v1: 47}
            ]
        },
        { 
            id: 1, variableName: "Físico",
            l_vals: [
                {v1: 47},
                {v1: 77}
            ]
        },
        { 
            id: 1, variableName: "Económico",
            l_vals: [
                {v1: 12},
                {v1: 55}
            ]
        }
    ];

    const generateDom = () => {
		return  <Card className='h-100'>
                    <Card.Header className="card-header-compact">
                        <Card.Title className="d-flex justify-content-between">
                            <b>{t('data-lang-boxname-contractadvance')}</b>
                        </Card.Title>
                    </Card.Header>
					<Card.Body className='px-2 h-100'>
							{
								inputParam_ComponentContent && inputParam_ComponentContent.items.map((item, index) => 
									<Row key={index} className='mx-0 pb-0 px-0 mx-auto border-bottom border-top'>
                                        {
                                            (item.variableName.indexOf("A.") !== -1) ?
										    <ItemGroup inputParam_Key={ index } inputParam_Object={item} />
                                            :
										    <ItemGroupCombined inputParam_Key={ index } inputParam_Object={item} />
                                        }
									</Row>
								)
							}
                            {
                                inputParam_ComponentContent && inputParam_ComponentContent.items.length === 0 &&
									<Row className='mx-1'>
									    <Col>
                                            <NoDataLayer display={true} text={t('data-lang-msg-noconsolidatedgroup-configured')} />
									    </Col>
									</Row>
                            }
					</Card.Body>
				</Card>
    }

    return (
        <>
            { generateDom() }
        </>
    );
}

SG3KPI_CONTRACT_ADVANCE.propTypes = {
};

export default SG3KPI_CONTRACT_ADVANCE;